import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    name: 'dashboard',
    path: '/',
    component: () => import('../views/Dashboard.vue')
  },
  {
    name: 'random',
    path: '/random',
    component: () => import('../views/Random.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
